import { Box, Image } from '@chakra-ui/react';
import { useEffect, useMemo } from 'react';
import { SIGNATURE_PAD_ASPECT_RATIO } from './VSignature.helpers';

export interface StoredSignatureProps {
  signature?: Blob;
}

export const StoredSignature = ({ signature }: StoredSignatureProps) => {
  const signatureUrl = useMemo(
    () => (signature ? URL.createObjectURL(signature) : null),
    [signature]
  );

  useEffect(() => {
    if (!signatureUrl) {
      return;
    }

    return () => URL.revokeObjectURL(signatureUrl);
  }, [signatureUrl]);

  return (
    <Box
      width="100%"
      aspectRatio={SIGNATURE_PAD_ASPECT_RATIO}
      borderWidth="1px"
      borderColor="border"
      rounded="md"
      background={'bg.subtle'}
    >
      {signatureUrl && <Image src={signatureUrl} alt="Signature" width="100%" />}
    </Box>
  );
};
